import { Box } from '@mui/material';
import PeriodFilter from '@/components/Base/PeriodFilter';
import React, { useEffect, useState } from 'react';
import { groupBy } from 'lodash';
import { useConsolidationPedagogicalHistorya } from './api/getConsolidationPedagogicalHistory';
import PedagogicalHistoryChart from '@/components/Base/PedagogicalHistoryChart';
import LoadingChart from '@/features/dashboard/components/LoadingChart';

const PedagogicalHistory = ({ year: yearProp }: { year?: number }) => {
  const { data, isFetched, isFetching } = useConsolidationPedagogicalHistorya(yearProp);
  const listYears = Object
    .keys(groupBy(data, 'ano'))
    .map((item) => Number(item))
    .sort((a, b) => b - a);

  const [year, setYear] = useState<number | null>(null);

  useEffect(() => {
    if (isFetched && listYears.length) {
      setYear(listYears[0])
    }
  }, [isFetched, listYears]);

  const onApplyFilter = (selectedYear) => {
    setYear(selectedYear)
  }

  const selected = data?.length ? data?.find((item) => Number(item.ano) === year) : null
  return (
    <>
      <LoadingChart loading={isFetching} />
      {
        data?.length && selected && (
          <PedagogicalHistoryChart title={'Histórico pedagógico dos alunos'} lineColor={'rgba(246, 190, 51, 1)'}
          pointColor={'rgba(224, 74, 76, 1)'} data={data}  />
        )
      }

      {
        isFetched && (
          <Box marginTop={'10px'}>
            <PeriodFilter year={year} years={listYears} onApplyFilter={onApplyFilter} />
          </Box>
        )
      }
    </>
  );
};

export default PedagogicalHistory;
